import React from "react";

const Button = ({ text, callBack, className, disabled, style }) => {
  return (
    <button
      onClick={callBack}
      className={`btn ${className}`}
      style={{ backgroundColor: "#2c3e50", color: "#ecf0f1", lineHeight: "normal", ...(style || {}) }}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Button;
